import { DefaultEnvironment } from './environment.def';

export const environment = Object.assign<DefaultEnvironment, DefaultEnvironment>(new DefaultEnvironment(), {
    dev: true,
    production: false,
    mode: 'dev',
    systemState: 'Seattle',
    apiUrl: 'http://localhost:8080',
    socketUrl: 'http://localhost:8080/ws-endpoint',
    systemSeattleUrl: 'https://sys.acadiacraft.com:20443/',
    systemCaliforniaUrl: 'https://sys.acadiacraft.com:20443/',
    systemCartTvUrl: 'https://sys.acadiacraft.com:20443/cart-tv-test/'
})
